<template>
  <div class="error-state">
    <i class="pi pi-exclamation-triangle" />
    <h3>Beklager, noe gikk galt</h3>
    <p>{{ errorMessage }}</p>
    <BaseButton text="Prøv igjen" @click="handleRetry" />
  </div>
</template>

<script setup lang="ts">
import BaseButton from "@/components/Base/BaseButton/BaseButton.vue";

// Types
interface Props {
  errorMessage: string;
}

// Props
defineProps<Props>();

// Emits
const emit = defineEmits(["retry"]);

// Event handlers
const handleRetry = (): void => {
  emit("retry");
};
</script>

<style lang="scss" scoped>
.error-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4rem;
  text-align: center;

  i {
    font-size: 3rem;
    margin-bottom: 1rem;
    color: $color-error;
  }

  h3 {
    margin: 1rem 0;
    font-weight: 500;
  }

  p {
    margin-bottom: 1rem;
    font-weight: 400;
  }
}
</style>
